import type { MacroInputCaptureRequest, PlaycastMessage, PlaycastMacroInputCaptureMessages } from '../types';
import { formatMessage } from './_util/formatMessage';

export function request(hostId: string, message: MacroInputCaptureRequest): PlaycastMessage<PlaycastMacroInputCaptureMessages> {
  return formatMessage(hostId, 'host', { target: 'system', action: 'macroRecorderInputCapture', isReply: false, message }) as PlaycastMessage<PlaycastMacroInputCaptureMessages>;
}
export function native(hostId: string, message: MacroInputCaptureRequest, localEditor: boolean): PlaycastMessage<PlaycastMacroInputCaptureMessages> {
  return formatMessage(hostId, 'host', { target: 'record', action: 'inputs', isReply: false, message: { ...message, localEditor } }) as PlaycastMessage<PlaycastMacroInputCaptureMessages>;
}
